import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgMessage24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7C18.1045 7 18.9998 7.89558 19 9V15C19 16.1046 18.1046 17 17 17H10.9404L8.1377 19.8027C7.71773 20.2219 7.00028 19.9245 7 19.3311V17C5.89543 17 5 16.1046 5 15V9C5.00018 7.89558 5.89554 7 7 7H17ZM8 13.334V14.334H14V13.334H8ZM8 12.334H16V11.334H8V12.334ZM8 10.334H16V9.33398H8V10.334Z",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessage24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=Message24.svg.js.map
